import { Component, Inject } from '@angular/core';
import { Tierarzt } from '../../../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { TierwohlprotokollSchwein } from '../classes/tierwohlprotokoll-schwein';
import { LocalStorageService } from '../../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { Client } from '../../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { FormControl } from '@angular/forms';

/** 0/1-Flags aus der API oft als String "0"/"1" – fuer Radios/Checkboxen normalisieren. */
const TWP_SCHWEIN_FLAG_FIELDS: (keyof TierwohlprotokollSchwein)[] = [
    'gesundheitsstatus_prrs',
    'gesundheitsstatus_app',
    'bestand_klinisch_ohne_befund',
    'hinweise_tierseuchen',
    'mangagementfaktor_haltungssystem',
    'managementfaktor_fuetterung_wasserversorgung',
    'managementfaktor_betrieb',
    'managementfaktor_hygiene',
    'managementfaktor_zucht',
    'managementfaktor_sonstiges',
    'gesundheitsstatus_atmungsorgane',
    'gesundheitsstatus_verdauungsapparat',
    'gesundheitsstatus_bewegungsapparat',
    'gesundheitsstatus_haut_kondition',
    'gesundheitsstatus_sonstiges',
    'diagnostische_massnahmen_sektion',
    'diagnostische_massnahmen_kot',
    'diagnostische_massnahmen_resistenztest',
    'diagnostische_massnahmen_hautgeschabsel',
    'diagnostische_massnahmen_blut',
    'diagnostische_massnahmen_futter_wasser',
    'diagnostische_massnahmen_tupfer',
    'diagnostische_massnahmen_sonstiges',
    'salmonellen_monitoring',
    'antibiotika_monitoring',
    'schlacht_befunddaten',
    'betriebliche_eigenkontrolle',
    'tierschutzindikatoren',
    'stallklima_kontrolliert',
    'impfprogramm_influenza',
    'impfprogramm_prrs',
    'impfprogramm_rotlauf',
    'impfprogramm_circo',
    'impfprogramm_rhinitis_atr',
    'impfprogramm_ileitis',
    'impfprogramm_haemophilus',
    'impfprogramm_mycoplasmen',
    'impfprogramm_app',
    'impfprogramm_parvo',
    'impfprogramm_sonstiges',
    'parasitologische_massnahmen_endoparasiten',
    'parasitologische_massnahmen_ektoparasiten',
    'plan_tiergesundheit_hygienemanagement',
    'massnahmenplan_einzelaktivitaeten',
    'abrechnen',
];

@Component({
    selector: 'kiene-tierwohlprotokoll-schwein-details',
    templateUrl: './tierwohlprotokoll-schwein-details.component.html',
    styleUrls: ['./tierwohlprotokoll-schwein-details.component.scss'],
})
export class TierwohlprotokollSchweinDetailsComponent {
    protected readonly KieneUtils = KieneUtils;

    tierwohlprotokollSchwein: TierwohlprotokollSchwein;
    selectedKunde: Client;
    selectedTierarzt: Tierarzt;
    userIstTierarzt = false;
    abrechnenCtrl = new FormControl(true);

    constructor(
        public dialogRef: MatDialogRef<TierwohlprotokollSchweinDetailsComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl,
        private api: KieneTableService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
    ) {
        if (data?.tierwohlprotokollSchwein) {
            this.tierwohlprotokollSchwein = data?.tierwohlprotokollSchwein;
            this.normalizeApiFlags(this.tierwohlprotokollSchwein);
            this.generateObjsForAutocompletes();
        } else {
            this.tierwohlprotokollSchwein = new TierwohlprotokollSchwein();
            this.tierwohlprotokollSchwein.status_id = 153;
        }

        if (KieneUtils.isApiZero(this.tierwohlprotokollSchwein.abrechnen)) {
            this.abrechnenCtrl.setValue(false);
        } else if (KieneUtils.isApiOne(this.tierwohlprotokollSchwein.abrechnen)) {
            this.abrechnenCtrl.setValue(true);
        }
        if (this.tierwohlprotokollSchwein.abgabebeleg_id) {
            this.abrechnenCtrl.disable();
        }

        if (!this.tierwohlprotokollSchwein.datum) {
            this.tierwohlprotokollSchwein.datum = new Date();
        }

        if (localStorageService.getCurrentClient()) {
            this.selectedKunde = localStorageService.getCurrentClient();
            this.setKunde(this.selectedKunde);
        }

        this.userIstTierarzt = localStorageService.isCurrentUserVeterinarian();
        if (this.userIstTierarzt) {
            const session = localStorageService.getCurrentUser();
            this.selectedTierarzt = new Tierarzt();
            this.selectedTierarzt.tierarzt_id = session.tierarzt_id;
            this.selectedTierarzt.vorname = session.vorname;
            this.selectedTierarzt.nachname = session.nachname;
            this.setTierarzt(this.selectedTierarzt);
        }
    }

    save() {
        this.normalizeNullableDates(this.tierwohlprotokollSchwein);
        this.tierwohlprotokollSchwein.abrechnen = this.abrechnenCtrl.value ? 1 : 0;
        if (!this.tierwohlprotokollSchwein.status_id) {
            this.tierwohlprotokollSchwein.status_id = 153;
        }
        if (this.tierwohlprotokollSchwein.twp_schwein_id) {
            this.api
                .updateEntity(this.apiBaseUrl + 'tierwohlprotokoll_schwein/update.php', this.tierwohlprotokollSchwein)
                .subscribe({
                    next: () => {
                        this.messageService.infoMessage('Tierwohlprotokoll wurde erfolgreich aktualisiert.');
                        this.dialogRef.close(true);
                    },
                    error: error => {
                        this.messageService.errorMessage('Fehler beim Aktualisieren des Tierwohlprotokolls!', error);
                    },
                });
        } else {
            this.api
                .post(this.apiBaseUrl + 'tierwohlprotokoll_schwein/create.php', this.tierwohlprotokollSchwein)
                .subscribe({
                    next: () => {
                        this.messageService.infoMessage('Tierwohlprotokoll wurde erfolgreich erstellt.');
                        this.dialogRef.close(true);
                    },
                    error: error => {
                        this.messageService.errorMessage('Fehler beim Erstellen des Tierwohlprotokolls!', error);
                    },
                });
        }
    }

    private normalizeNullableDates(twp: {
        parasitologische_massnahmen_endoparasiten_zuletzt?: Date | string | null;
        parasitologische_massnahmen_ektoparasiten_zuletzt?: Date | string | null;
    }) {
        const dateKeys = [
            'parasitologische_massnahmen_endoparasiten_zuletzt',
            'parasitologische_massnahmen_ektoparasiten_zuletzt',
        ] as const;
        for (const key of dateKeys) {
            const value = twp[key];
            if (value == null || value === '' || (value instanceof Date && Number.isNaN(value.getTime()))) {
                twp[key] = null;
            }
        }
    }

    setKunde(c: Client) {
        this.tierwohlprotokollSchwein.kunde_id = c.kunde_id;
        this.tierwohlprotokollSchwein.kunde = c.bezeichnung_final;
        this.tierwohlprotokollSchwein.kunde_vvvo = c.vvvo;
        this.tierwohlprotokollSchwein.kunde_strasse = c.strasse_final;
        this.tierwohlprotokollSchwein.kunde_plz = c.plz_final;
        this.tierwohlprotokollSchwein.kunde_ort = c.ort_final;
    }

    setTierarzt(t: Tierarzt) {
        this.tierwohlprotokollSchwein.tierarzt_id = t.tierarzt_id;
        this.tierwohlprotokollSchwein.tierarzt_vorname = t.vorname;
        this.tierwohlprotokollSchwein.tierarzt_nachname = t.nachname;
    }

    private normalizeApiFlags(twp: TierwohlprotokollSchwein) {
        for (const key of TWP_SCHWEIN_FLAG_FIELDS) {
            const value = twp[key];
            if (value == null || value === ('' as never)) {
                (twp as any)[key] = null;
            } else if (KieneUtils.isApiOne(value)) {
                (twp as any)[key] = 1;
            } else if (KieneUtils.isApiZero(value)) {
                (twp as any)[key] = 0;
            }
        }
        if (twp.status_id != null && twp.status_id !== ('' as never)) {
            twp.status_id = Number(twp.status_id);
        }
    }

    private generateObjsForAutocompletes() {
        if (this.tierwohlprotokollSchwein?.kunde_id) {
            this.loadKunde(this.tierwohlprotokollSchwein?.kunde_id).subscribe({
                next: value => {
                    this.selectedKunde = value;
                },
                error: () => {
                    this.selectedKunde = new Client();
                    this.selectedKunde.kunde_id = this.tierwohlprotokollSchwein.kunde_id;
                    this.selectedKunde.bezeichnung_final = this.tierwohlprotokollSchwein.kunde;
                    this.selectedKunde.vvvo = this.tierwohlprotokollSchwein.kunde_vvvo;
                    this.selectedKunde.strasse_final = this.tierwohlprotokollSchwein.kunde_strasse;
                    this.selectedKunde.plz_final = this.tierwohlprotokollSchwein.kunde_plz;
                    this.selectedKunde.ort_final = this.tierwohlprotokollSchwein.kunde_ort;
                },
            });
        }

        if (this.tierwohlprotokollSchwein?.tierarzt_id) {
            this.loadTierarzt(this.tierwohlprotokollSchwein.tierarzt_id).subscribe({
                next: value => {
                    this.selectedTierarzt = value;
                },
                error: () => {
                    this.selectedTierarzt = new Tierarzt();
                    this.selectedTierarzt.tierarzt_id = this.tierwohlprotokollSchwein.tierarzt_id;
                    this.selectedTierarzt.vorname = this.tierwohlprotokollSchwein.tierarzt_vorname;
                    this.selectedTierarzt.nachname = this.tierwohlprotokollSchwein.tierarzt_nachname;
                },
            });
        }
    }

    private loadKunde(kunde_id: number) {
        return this.api.getOne(this.apiBaseUrl + 'kunde/read_one.php', 'kunde_id', kunde_id.toString());
    }

    private loadTierarzt(tierarzt_id: number) {
        return this.api.getOne(this.apiBaseUrl + 'tierarzt/read_one.php', 'tierarzt_id', tierarzt_id.toString());
    }
}
